module.exports = __webpack_public_path__ + "static/media/badge-google-play-rounded.1d85daa2.png";